import { stores } from 'stores';
import { observer } from 'mobx-react';
import React from 'react';
import { StackModal } from 'Components/StackModal';
import { useWindowSize } from 'common/utils/style.util';
import { SvgWrapper } from 'common/ui/themes/disona/atoms/SvgWrapper';
import { S } from './style';

export const DisonaCTAModal = observer(
  ({ modalID, icon, heading, onClose, children, buttonText, greenButton }) => {
    const { height } = useWindowSize();
    const onCloseClick = () => {
      stores.ModalStore.hideModal(modalID);
      onClose();
    };
    return (
      <StackModal modalID={modalID}>
        <S.CTAContainer>
          <S.Header>
            <h2>Disona</h2>
          </S.Header>
          <S.Body height={height}>
            <S.Main>
              <S.Content>
                <SvgWrapper
                  width="80px"
                  height="80px"
                  style={{ marginBottom: '24px' }}
                  color="white"
                >
                  {icon}
                </SvgWrapper>
                <h2>{heading}</h2>
                <span>{children}</span>
              </S.Content>
              <S.Footer>
                <S.BackButton onClick={onCloseClick} greenButton={greenButton}>
                  {buttonText || 'Back to site'}
                </S.BackButton>
              </S.Footer>
            </S.Main>
          </S.Body>
        </S.CTAContainer>
      </StackModal>
    );
  }
);
